import { IExercise, ExerciseData } from '../exercise';

export class ExeEmpty implements IExercise {
  readonly name = 'Empty';
  readonly fixedHeight = 0;
  readonly noWindow = true;
  readonly injectEq = false;
  readonly injectAbc = false;

  draw(_data: ExerciseData): void {
    // intentionally empty
  }
}
